import { formatNumber } from "../../util/helper-functions";

export const reportFields = [
  {
    title: "Electricity Bill",
    id: 1,
    name: "monthlyBill",
    unit: "$",
    defaultValue: 140,
  },
  {
    title: "Roof Sq Meter ",
    id: 2,
    name: "roofSquareMeter",
    defaultValue: 25000,
    unit: "sq/m",
  },
  {
    title: "Average Solar Radiation",
    id: 3,
    name: "averageSolarRadiation",
    defaultValue: 3000,
    unit: "kWh/m2/day",
  },
];

// Now useless
export const formatFieldValue = (value, unit) => {
  const formatedNumber = formatNumber(value);
  switch (unit) {
    case "$":
      return `${unit} ${formatedNumber}`;
    default:
      return `${formatedNumber} ${unit} `;
  }
};
